export default class TableOfContents {
    constructor() {
        this.tocContainer = document.getElementById('toc');
        if (!this.tocContainer) return;
        
        this.init();
    }

    init() {
        // Get all h2 and h3 headings from the content
        const headings = document.querySelectorAll('#results-content .toc-anchor');
        
        // Create the table of contents
        const tocList = document.createElement('ul');
        tocList.className = 'toc-list';
        
        headings.forEach(heading => {
            // Generate ID if it doesn't exist
            if (!heading.id) {
                heading.id = this.generateId(heading.textContent);
            }
            
            const listItem = document.createElement('li');
            const link = document.createElement('a');
            
            // Set the link text and href
            link.innerHTML = heading.innerHTML;
            link.href = `#${heading.id}`;
            
            // Add appropriate class based on heading level
            // link.className = heading.tagName.toLowerCase() === 'h2' ? 'toc-h2' : 'toc-h3';
            
            listItem.appendChild(link);
            tocList.appendChild(listItem);
        });
        
        // Add the table of contents to the container
        this.tocContainer.appendChild(tocList);
    }

    generateId(text) {
        // Convert text to lowercase and replace spaces with hyphens
        let id = text.toLowerCase()
            .replace(/[^a-z0-9]+/g, '-') // Replace any non-alphanumeric chars with hyphens
            .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
        
        // Add a random number to ensure uniqueness
        const random = Math.floor(Math.random() * 1000);
        return `${id}-${random}`;
    }
} 